import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgExternalLink = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.429 11.064v2.143a1.93 1.93 0 0 1-1.929 1.929H5.929A1.93 1.93 0 0 1 4 13.207V7.636a1.93 1.93 0 0 1 1.929-1.929h4.714c.12 0 .214.094.214.214v.429c0 .12-.094.214-.214.214H5.929c-.59 0-1.072.482-1.072 1.072v5.571c0 .59.482 1.072 1.072 1.072H11.5c.59 0 1.071-.483 1.071-1.072v-2.143c0-.12.094-.214.215-.214h.428c.12 0 .215.094.215.214zM16 5.28v3.428a.432.432 0 0 1-.429.429.426.426 0 0 1-.3-.128L14.09 7.83l-4.366 4.366a.23.23 0 0 1-.154.067.23.23 0 0 1-.154-.067l-.763-.763a.23.23 0 0 1-.067-.154.23.23 0 0 1 .067-.154l4.366-4.367-1.178-1.178a.426.426 0 0 1-.128-.301c0-.235.194-.429.429-.429h3.428c.235 0 .429.194.429.429z"
      />
    </svg>
  );
};
export default SvgExternalLink;
